'use client'

import { useTranslations } from 'next-intl'
import { flagshipAccentAt, FLAGSHIP_ACCENT_VAR } from '@/lib/flagship-colors'
import { LegalPage, GlassSection } from './legal/LegalPage'

const accent = (i: number) => FLAGSHIP_ACCENT_VAR[flagshipAccentAt(i)]

interface TermsSection {
  heading: string
  paragraphs?: string[]
  items?: string[]
}

export default function WebsiteCheckTermsPageClient() {
  const t = useTranslations('legal.websiteCheckTerms')
  const sections = t.raw('sections') as TermsSection[]

  return (
    <LegalPage title={t('title')} subtitle={t('subtitle')}>
      {sections.map((section, i) => (
        <GlassSection key={section.heading} title={section.heading} accent={accent(i)}>
          {section.paragraphs?.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
          {section.items && (
            <ul className="list-inside list-disc space-y-1">
              {section.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          )}
        </GlassSection>
      ))}

      <p className="mx-auto max-w-none! text-center text-sm text-[var(--flagship-muted)]">
        {t('lastUpdated')}
      </p>
    </LegalPage>
  )
}
